import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

/*
  There is an issue with OperationDateTimeComponent
  Month/year selector creates angular cdk overlay. When we click on item on the year/month list, it
  closes a filter component. To prevent it we need to add a class to overlay created by 3rd party lib.
  To prevent that behavior on any cdk overlay created in operation input (and its children) we add to its
  injector NonClosableOverlayService that adds ag-grid's 'ag-custom-component-popup' class.
*/
@Injectable()
export class NonClosableOverlayService extends Overlay {
  override create(config?: OverlayConfig) {
    const AG_GRID_CLASS = 'ag-custom-component-popup';
    config = { ...config, panelClass: AG_GRID_CLASS, backdropClass: AG_GRID_CLASS };
    return super.create(config);
  }
}
